// services/baseApi.js
// /* eslint-disable */

import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from "js-cookie";

export const baseApi = createApi({
  reducerPath: "baseApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.NEXT_PUBLIC_API_URL,
    prepareHeaders: (headers, { endpoint, body }) => {
      // Ngrok free tier returns an HTML interstitial unless this header is sent (breaks JSON APIs).
      const apiUrl = process.env.NEXT_PUBLIC_API_URL || "";
      if (apiUrl.includes("ngrok")) {
        headers.set("ngrok-skip-browser-warning", "69420");
      }

      // Get the token from cookies and set the Authorization header
      const token = Cookies.get("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }

      // Let browser set multipart boundary automatically for FormData
      if (body instanceof FormData) {
        headers.delete("Content-Type");
      } else if (typeof body === "object" && body !== null) {
        headers.set("Content-Type", "application/json");
      }

      return headers;
    },
  }),
  tagTypes: [
    "Sessions",
    "Packages",
    "Memberships",
    "Instructors",
    "Clients",
    "Leads",
    "Attendance",
    "Schedules",
    "Forms",
    "Dashboard",
    "Interested",
    "Document",
    "Documents",
    "TermsDocument",
    "LeadSource",
    "LeadStatus",
    "Category",
    "BookingStatus",
    "SessionTypes",
    "Settings",
    "Referrals",
    "Discounts",
    "Payment",
    "PaymentModes",
    "Customer Form",
    "User",
    "RescheduleRequests",
    "NotificationSettings",
    "FormSubmissionAlerts",
    "ScheduleTrialAlerts",
    "IntegrationAlerts",
    "GoogleIntegration",
    "MetaLeads",
  ],
  endpoints: () => ({}), // Define your endpoints here
});

export default baseApi;
